// Copyright (c) 2023 WiseTime. All rights reserved.

import React from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components/macro"
import { Trans } from "@lingui/react"
import { Paper } from "../../shared/styles"
import TimesheetDrawerTip from "../timesheet/TimesheetDrawerTip"
import * as TimelineAdditionalUiSlice from "../slices/additionalUi"
import { DeselectButton } from "./ActionPaneHeaderWithTimeRows"
import SvgIcon from "../../shared/SvgIcon"

const Wrapper = styled.div`
  ${Paper};
  position: relative;
  color: ${({ theme }) => theme.colors.nero};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
  
  h3 {
    margin-bottom: 1rem;
  }
  
  p {
    line-height: 18px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: ${({ theme }) => theme.screen.sm}) {
    display: none;
  }
`

const StyledTimesheetDrawerTip = styled(TimesheetDrawerTip)`
  text-align: left;
  margin-top: 2rem;
`

const Tips = () => {
  const dispatch = useDispatch()
  const timesheetScrolledOut = useSelector(TimelineAdditionalUiSlice.selectTimesheetScrolledOut)
  const timesheetIsPinned = useSelector(TimelineAdditionalUiSlice.selectTimesheetIsPinned)
  const actionPaneNoteIsHidden = useSelector(TimelineAdditionalUiSlice.selectActionPaneNoteIsHidden)
  return (
    <>
      {!actionPaneNoteIsHidden && (
        <Wrapper>
          <DeselectButton
            type="button"
            onClick={() => dispatch(TimelineAdditionalUiSlice.setActionPaneNoteIsHidden(true))}
          >
            <SvgIcon name="close"/>
          </DeselectButton>
          <p><Trans id="label_new_timeline_text_1" message="Your recorded time will appear in the timeline section, ready to be added to the timesheet. Once you create a timesheet entry, you can update its tag, activity type and narrative in the table above."/></p>
          <p><Trans id="label_new_timeline_text_2" message="All entries are private until you post them to your team."/></p>
        </Wrapper>
      )}
      {timesheetScrolledOut && !timesheetIsPinned && <StyledTimesheetDrawerTip/>}
    </>
  )
}

export default Tips
